import React from 'react';
import {observer} from 'mobx-react'
import Col from '../base-components/Col'
import { BaseUIComponentProps, DomainAttrInUIComponentProps } from './BaseUIComponent';
import { IDomainData, IUITextBoxDef } from '../../datatypes';

interface TextBoxProps extends BaseUIComponentProps{
    /** @override */
    metadata: IUITextBoxDef;
    
    /** @override */
    domainAttribute:DomainAttrInUIComponentProps;    
}

class TextBox extends React.Component<TextBoxProps,{}> {

  render() {
    const props = this.props as TextBoxProps & {[key:string]:IDomainData};
    const {metadata, domainAttribute} = this.props;

    const {
      properties,
      messageKey,
      cssClasses,
    } = metadata;

    let value = messageKey;
    let {xs, sm, md, lg} = properties;
    let className = cssClasses ? cssClasses : '';

    if(domainAttribute && props[domainAttribute.objectName]) {
      value = props[domainAttribute.objectName][domainAttribute.name] as string;
    }
    return (
      <Col xs={xs} sm={sm} md={md} lg={lg}>
        <div className={className}>
          {value}
        </div>
      </Col>
    )
  }
}

export default observer(TextBox);